import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./msalConfig";
import Login from "./login/Login"
import ProtectedRoutesWrapper from "./login/ProtectedRoutesWrapper";
import CreateProject from "./pages/CreateProject";
import UpdateProject from "./pages/UpdateProject";
import NotFound from "./pages/NotFound";

const App: React.FC = () => {
  return (
      <MsalProvider instance={msalInstance}>
          <Router>
              <Routes>
                  <Route path="/" element={<Login />} />
                  <Route element={<ProtectedRoutesWrapper />}>
                      <Route path="/create-project" element={<CreateProject />} />
                      {/*<Route path="/update-project" element={<UpdateProject />} />*/}
                  </Route>
                  <Route path="*" element={<NotFound />} />
              </Routes>
          </Router>
      </MsalProvider>
  );
};

export default App;
